
import { supabase } from '@/integrations/supabase/client'
import type { LearnModule, ModuleFormData } from '@/types/module'

export const moduleService = {
  async fetchModules(): Promise<LearnModule[]> {
    const { data, error } = await supabase
      .from('learn_modules')
      .select('*')
      .order('category, order_index')

    if (error) throw error
    console.log('Fetched modules:', data)
    return data || []
  },

  async createModule(formData: ModuleFormData): Promise<LearnModule[]> {
    const { data, error } = await supabase
      .from('learn_modules')
      .insert({
        title: formData.title,
        description: formData.description,
        category: formData.category,
        coins: parseInt(formData.coins) || 100,
        image_url: formData.image_url || null,
        order_index: parseInt(formData.order_index) || 1
      })
      .select()

    if (error) throw error
    console.log('Module created successfully:', data)
    return data || []
  },

  async updateModule(moduleId: string, formData: ModuleFormData): Promise<void> {
    console.log('Updating module:', moduleId, 'with data:', formData)
    
    const updateData = {
      title: formData.title,
      description: formData.description,
      category: formData.category,
      coins: parseInt(formData.coins) || 100,
      image_url: formData.image_url || null,
      order_index: parseInt(formData.order_index) || 1,
      updated_at: new Date().toISOString()
    }
    
    const { data, error } = await supabase
      .from('learn_modules')
      .update(updateData)
      .eq('id', moduleId)
      .select()

    if (error) throw error
    
    if (!data || data.length === 0) {
      throw new Error('No module was updated. Please check if the module ID is correct.')
    }
    
    console.log('Module updated successfully:', data[0])
  },

  async deleteModule(moduleId: string): Promise<void> {
    // First delete related content
    const { error: contentError } = await supabase
      .from('learn_content')
      .delete()
      .eq('module_id', moduleId)

    if (contentError) {
      console.warn('Error deleting module content:', contentError)
    }

    // Then delete the module
    const { error } = await supabase
      .from('learn_modules')
      .delete()
      .eq('id', moduleId)

    if (error) throw error
    console.log('Module deleted successfully')
  }
}
